/* ============================================================
   La Nani — reveal la scroll
   Vezi theme/CLAUDE.md, sectiunea 7.

   Trei principii:

   1. Continutul e vizibil implicit. Starea ascunsa se aplica doar dupa
      ce scriptul a confirmat ca o poate scoate, prin clasa .ln-js pusa
      pe <html>. Fara JS — oprit, eroare, crawler — continutul ramane
      vizibil in loc sa dispara.

   2. In theme editor nu ascundem NIMIC, niciodata. Cand editezi un camp,
      Shopify redeseneaza sectiunea din server; elementele noi vin fara
      clasa .is-in si, daca .ln-js e deja pe <html>, raman la opacity 0.
      Rezultatul: iti dispare pagina sub mana in timp ce scrii. Acolo
      afisam tot, direct.

   3. Scanarea se poate relua. Orice continut aparut ulterior — sectiune
      redesenata, widget de aplicatie — e preluat automat.
   ============================================================ */
(function () {
  'use strict';

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* evenimentele pe care Shopify le trimite cand redeseneaza ceva in editor */
  var SHOPIFY_EVENTS = [
    'shopify:section:load',
    'shopify:section:select',
    'shopify:section:reorder',
    'shopify:block:select'
  ];

  function pending() {
    return [].slice.call(document.querySelectorAll('.ln-reveal:not(.is-in)'));
  }

  function showAll() {
    pending().forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ruleaza fn cel mult o data pe cadru */
  function throttled(fn) {
    var queued = 0;
    return function () {
      if (queued) return;
      queued = requestAnimationFrame(function () { queued = 0; fn(); });
    };
  }

  function onNewContent(fn) {
    SHOPIFY_EVENTS.forEach(function (ev) { document.addEventListener(ev, fn); });
    if ('MutationObserver' in window) {
      /* doar childList: schimbarile de clasa nu ne intereseaza, altfel
         adaugarea lui .is-in ar declansa observerul la nesfarsit */
      new MutationObserver(fn).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  /* ---------- cazurile in care nu ascundem nimic ---------- */
  if (designMode || reduced) {
    showAll();
    onNewContent(throttled(showAll));
    return;
  }

  /* ---------- reveal normal ---------- */
  var items = [];
  var netTimer = 0;
  var works = false;

  function tick() {
    var h = window.innerHeight || document.documentElement.clientHeight;
    for (var i = items.length - 1; i >= 0; i--) {
      var r = items[i].getBoundingClientRect();
      /* ~12% vizibil, ca in CLAUDE.md */
      if (r.top < h * 0.88 && r.bottom > 0) {
        items[i].classList.add('is-in');
        items.splice(i, 1);
        /* calculul da rezultate: plasa de siguranta nu mai e necesara */
        works = true;
        if (netTimer) { clearTimeout(netTimer); netTimer = 0; }
      }
    }
  }

  function scan() {
    items = pending();
    if (!items.length) return;

    /* de aici incolo putem ascunde in siguranta */
    document.documentElement.classList.add('ln-js');
    tick();

    /* Plasa de siguranta: daca in 3 secunde nu s-a afisat nimic, ceva a
       blocat calculul. Aratam tot, ca sa nu ramana pagina goala.
       Odata ce un element a aparut normal, plasa se dezarmeaza si
       reveal-ul isi face treaba pana jos. */
    if (!works && !netTimer) netTimer = setTimeout(showAll, 3000);
  }

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);
  onNewContent(throttled(scan));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
